import React from "react";
import moment from "moment";

const CustomBarComponent = ({
  bar: {
    x,
    y,
    width,
    color,
    data: {
      data: { monthValueColor, month, monthValue },
    },
  },
  shouldRenderLabel,
}: any): JSX.Element => {
  return (
    <g transform={`translate(${x}, ${y})`}>
      <text
        x={-10}
        y={14}
        textAnchor="end"
        dominantBaseline="middle"
        fillOpacity="1"
        style={{
          fontFamily: "Mangueira",
          fontSize: 10,
          fill: "#929292",
          fontWeight: "bold",
          pointerEvents: "none",
        }}
      >
        {moment(month).format("MMM/YY")}
      </text>
      <rect
        width={width === 0 ? 1 : width + 1}
        height={30}
        fill={monthValueColor}
        strokeWidth="0"
        stroke={color}
        // eslint-disable-next-line react/no-unknown-property
        focusable="false"
        ry={5}
        style={{
          borderBottomRightRadius: 25,
          borderTopRightRadius: 25,
        }}
      />
      {shouldRenderLabel && (
        <text
          x={width + 35}
          y={14}
          textAnchor="end"
          dominantBaseline="middle"
          fillOpacity="1"
          style={{
            fontFamily: "Mangueira",
            fontSize: 10,
            fill: "#929292",
            fontWeight: "bold",
            pointerEvents: "none",
          }}
        >
          {monthValue}
        </text>
      )}
    </g>
  );
};

export default CustomBarComponent;
